module.exports = __webpack_public_path__ + "static/media/profile-background.eb24cce3.png";